import React, { useLayoutEffect } from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { DOCUMENT_TYPE_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes, matchPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import Content from "../../../layout/Content";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import InternalResource from '../../../common/resource/InternalResource';
import DocumentTypeBasicInformationResource from "./resources/DocumentTypeBasicInformationResource";
import DocumentTypeToolbar from "./DocumentTypeToolbar";
import { clearDocumentType, getDocumentType } from "../../../../actions";

export const DocumentType = ({
    breadcrumbs,
  dispatchGetDocumentType,
  dispatchClearDocumentType,
  match: {
    params: { id: documentTypeId },
  },
  loading,
  documentType,
}) => {
  useLayoutEffect(() => {
    dispatchGetDocumentType({ documentTypeId });

    return () => dispatchClearDocumentType();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (documentType.isEmpty())
    content = <NoDataResource returnPage={DOCUMENT_TYPE_PATH} />;
  else {
    const documentTypeJson = documentType.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <DocumentTypeBasicInformationResource {...documentTypeJson} />
        <InternalResource id={documentTypeJson.id}
          createDate={documentTypeJson.createDate}
          lastUpdate={documentTypeJson.lastUpdate}/>
      </>
    );

    toolbar = <DocumentTypeToolbar documentTypeId={documentTypeJson.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Tipo de Documento"
      content={content}
    />
  );
};

DocumentType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearDocumentType: PropTypes.func.isRequired,
  dispatchGetDocumentType: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  documentType: PropTypes.instanceOf(Immutable.Map).isRequired,
};

DocumentType.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearDocumentType: clearDocumentType,
  dispatchGetDocumentType: getDocumentType
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Documentos',
      href: DOCUMENT_TYPE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  documentType: BusUnit.DocumentType.getIn(['current', 'content']),
  loading: !BusUnit.DocumentType.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentType);